<template>
  <div
    class="container step-signal"
    v-if="$route.meta.extra"
    :style="{ background: $route.meta.extra.colors.primary }"
  >
    <div class="step-title">
      <h3 class="title is-1">{{ $route.meta.extra.step.number }}</h3>
      <br />
    </div>
    <div class="step-help helvetica">
      <h3 class="title is-4">{{ $t($route.meta.extra.step.text) }}</h3>
    </div>
    <div
      class="step-icon"
      :style="{
        background: $route.meta.extra.colors.dark,
        color: $route.meta.extra.colors.dark
      }"
    >
      <img :src="getStepIconSrc()" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getStepIconSrc: function() {
      return require('@/assets/' + this.$route.meta.extra.step.icon + '.svg')
    }
  }
}
</script>
<style lang="scss">
@import '~@/scss/_mixins.scss';

.container.step-signal {
  display: flex;
  width: 28%;
  left: 0;
  top: 5rem;
  position: absolute;
  background-size: cover;
  background-position-y: center;
  height: 120px;
  z-index: 40;
  min-width: 230px;
  max-width: 340px;

* {
  color: white;
}

  @include xs {
    display: none;
  }

  @include sm {
    display: none;
  }

  @include md {
    display: none;
  }

  .step-title {
    width: 20%;
    height: 100%;
    text-align: center;
    line-height: 0;
    margin-bottom: 0px;
    display: flex;
    flex-wrap: wrap;

    h3 {
      margin: auto;
      color: white;
      font-size: 80px;
    }
    span {
      margin: auto;
      margin-top: 0;
    }
  }
  .step-help {
    width: 45%;
    display: flex;
    margin: auto;
    margin-left: 5px;
  }
  .step-icon {
    width: 25%;
    display: flex;
    padding: 2.5%;

    img {
      margin: auto;
      width: 80%;
      height: auto;
      max-height: 100%;
    }
    &:before {
      content: '◀';
      font-size: 25px;
      position: absolute;
      right: 24%;
      top: 50%;
      transform: translateY(-50%);
      color: inherit;
    }
  }
}
</style>
